import { Avatar, Box, Chip, Typography } from "@mui/joy";
import { CheckCircle2, EllipsisVertical, Hammer, MessageSquare, Pause, Target, XCircle } from "lucide-react";
import moment from "moment";

interface GridCellProps {
    value: any;
    data: any;
}

export function GFCUser(props: GridCellProps) {
    const { value, data } = props;
    return (
        <Box display={"flex"} gap={2} alignItems={"center"} py={1.5}>
            <Avatar size="sm" alt={data.CustomerName} sx={{ border: "1px solid", borderColor: "divider" }}>
                {data?.CustomerName?.charAt(0)}
            </Avatar>
            <Box>
                <Typography level="body-sm" sx={{ fontWeight: 500 }} gutterBottom>
                    {data?.CustomerName}
                </Typography>
                <Typography level="body-sm">{data?.CustomerPhoneNumber}</Typography>
            </Box>
        </Box>
    );
}
export function GFCDescription(props: GridCellProps) {
    const { value, data } = props;
    return (
        <Box display={"flex"} gap={2} alignItems={"center"} py={1} height={"100%"}>
            {/* <Typography level="body-sm">{value}</Typography> */}
            <Box>
                <Typography level="body-sm" gutterBottom>
                    {data?.CustomerStreet},
                </Typography>
                <Typography level="body-sm">
                    {data?.CustomerCity},{data?.CustomerZipCode}
                </Typography>
            </Box>
        </Box>
    );
}

export function GFCTimestamp(props: GridCellProps) {
    const { value, data } = props;
    return (
        <Box display={"flex"} gap={2} alignItems={"center"} py={1} height={"100%"}>
            <Typography level="body-sm">{moment(value).format("MMM DD, YYYY")}</Typography>
        </Box>
    );
}

export function GFCNotes(props: GridCellProps) {
    const { value, data } = props;
    return (
        <Box display={"flex"} gap={2} alignItems={"center"} py={1} height={"100%"} justifyContent={"center"}>
            <MessageSquare size={16} />
        </Box>
    );
}

export function GFCMore(props: GridCellProps) {
    const { value, data } = props;
    return (
        <Box display={"flex"} gap={2} alignItems={"center"} py={1} height={"100%"} justifyContent={"center"}>
            <EllipsisVertical size={14} />
        </Box>
    );
}

export function GFCStatus(props: any) {
    const { value } = props;

    // Define icon and color based on status
    const statusMeta = {
        "NOT-STARTED": {
            color: "neutral",
            icon: <Pause size={12} />,
        },
        "IN-PROGRESS": {
            color: "warning",
            icon: <Hammer size={12} />,
        },
        COMPLETED: {
            color: "success",
            icon: <CheckCircle2 size={12} />,
        },
        CANCELLED: {
            color: "danger",
            icon: <XCircle size={12} />,
        },
        PENDING: {
            color: "warning",
            icon: <Target size={12} />,
        },
    } as any;

    const meta = statusMeta[value] || {
        color: "neutral",
        icon: null,
    };

    return (
        <Box display="flex" alignItems="center" justifyContent="center" py={1} height="100%" px={2}>
            <Chip
                size="sm"
                variant="soft"
                color={meta.color as any}
                startDecorator={meta.icon}
                sx={{ borderRadius: 6, border: "1px solid", borderColor: "divider", width: 130 }}
            >
                {value}
            </Chip>
        </Box>
    );
}
